import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-0.5" };
const _hoisted_2 = { class: "text-xs text-(--colors-text-body-subtle)" };
const _hoisted_3 = ["data-testid"];
import { computed } from "vue";
/** Read-only label/value pair of the Résumé sidebar — absent values render "—". */
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResumeField',
    props: {
        label: {},
        value: { default: null },
        mono: { type: Boolean, default: false },
        testid: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const displayValue = computed(() => {
            const trimmed = props.value?.trim();
            return trimmed ? trimmed : "—";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("dt", _hoisted_2, _toDisplayString(__props.label), 1 /* TEXT */),
                _createElementVNode("dd", {
                    class: _normalizeClass(["text-xs font-medium text-(--colors-text-heading) dark:text-(--colors-text-white-default)", __props.mono ? 'font-mono' : '']),
                    "data-testid": __props.testid
                }, _toDisplayString(displayValue.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
            ]));
        };
    }
});
